import * as React from "react";

const fixture = {
  label: "TEST LABEL",
  checked: true,
  value: "test",
  onClick: null,
};

export default fixture;
